//@flow
import React from 'react';
import IosSwitch from '../../../../elements/IosSwitch/IosSwitch';
import {useProductContext} from '../../context';

export default function VariantStockSwitchAdornment() {
  const [enabled, setProduct] = useProductContext(
    product => !!product.stockSetting && product.stockSetting.enabled,
    false
  );

  const setEnabled = (enabled: boolean) => {
    setProduct({
      stockSetting: {
        enabled: !!enabled,
      },
    });
  };

  return (
    <IosSwitch onChange={e => setEnabled(e.target.checked)} checked={enabled} />
  );
}
